function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 200 200",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23967,0,0,0.603306,-31.7851,67.405)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 59,
    width: 121,
    height: 121,
    style: {
      fill: "none",
      stroke: "white",
      strokeWidth: "16.96px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.938547,0,0,1,6.55307,3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9,74L97.738,13L190.131,76",
    style: {
      fill: "none",
      stroke: "white",
      strokeWidth: "19.23px"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.eb22360aff7badae1281b0ce54fdc1c0.svg";
export { ForwardRef as ReactComponent };